/**
 * Element names of the `<ZREP>` document. The transcribed ДПС description
 * (ai/docs/prro-api.md) documents the JSON commands but **not** the Z-report
 * schema, so these follow the widely used `zrep01.xsd` shape. Before adding a
 * field, check it against `XsdSchemaZRep` from the `Schemas` command.
 */
export const Z_REPORT_SECTIONS = {
  head: "ZREPHEAD",
  sales: "ZREPREALIZ",
  returns: "ZREPRETURN",
} as const;

export const PAY_FORMS_CONTAINER = "PAYFORMS";

export const TAXES_CONTAINER = "TAXES";
